(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bowbie-collection"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.bowbie-collection').forEach((collectionSection) => {
    if (collectionSection.dataset.collectionReady === 'true') return;
    collectionSection.dataset.collectionReady = 'true';

    const filterShell = collectionSection.querySelector('[data-filter-shell]');
    const filterOpen = collectionSection.querySelector('[data-filter-open]');
    const filterApply = collectionSection.querySelector('[data-filter-apply]');
    const filterEmpty = collectionSection.querySelector('[data-filter-empty]');
    const filterVisibleCount = collectionSection.querySelector('[data-visible-count]');
    const filterCards = Array.from(collectionSection.querySelectorAll('[data-filter-card]'));
    const filterInputs = Array.from(collectionSection.querySelectorAll('[data-filter-group]'));
    const filterClearButtons = Array.from(collectionSection.querySelectorAll('[data-filter-clear]'));
    const collectionGrid = collectionSection.querySelector('#products');
    const isSingleSeries = collectionSection.dataset.singleSeries === 'true';
    const allowedSorts = ['manual', 'created-descending', 'title-ascending', 'title-descending', 'price-ascending', 'price-descending'];
    const requestedSort = new URL(window.location.href).searchParams.get('sort_by');
    let currentSort = allowedSorts.includes(requestedSort) ? requestedSort : collectionSection.dataset.defaultSort;
    if (!allowedSorts.includes(currentSort)) currentSort = isSingleSeries ? 'price-ascending' : 'manual';
    // Four matching covers form one desktop row or two mobile rows.
    // A series can return later, instead of occupying an entire catalogue section.
    const arrangeRowGroups = (cards) => {
      const series = new Map();
      cards.forEach(card => {
        const key = card.dataset.series || 'other';
        if (!series.has(key)) series.set(key, []);
        series.get(key).push(card);
      });
      const queues = [];
      const remainders = [];
      const averagePrice = group => group.reduce((sum, card) => sum + Number(card.dataset.price), 0) / group.length;
      const prices = cards.map(card => Number(card.dataset.price)).sort((a, b) => a - b);
      const priceAt = fraction => prices[Math.floor((prices.length - 1) * fraction)] || 0;
      // Rotate accessible, core and premium rows without depending on store currency.
      const rowTargets = [priceAt(.3), priceAt(.55), priceAt(.75), priceAt(.5)];
      series.forEach((members, key) => {
        const blocks = [];
        const pool = [...members];
        while (pool.length >= 4) {
          // One accessible choice, two middle choices and one higher priced choice
          // share a background. Keep the premium choice visible within the row.
          const entry = pool.shift();
          const middle = pool.splice(Math.floor((pool.length - 1) * .5), 1)[0];
          const premium = pool.splice(Math.floor((pool.length - 1) * .85), 1)[0];
          const core = pool.splice(Math.floor((pool.length - 1) * .5), 1)[0];
          blocks.push([entry, middle, premium, core]);
        }
        if (pool.length) remainders.push(pool);
        if (blocks.length) queues.push({key, blocks});
      });
      const ordered = [];
      const recentSeries = [];
      while (queues.length) {
        // Keep two other backgrounds between repeat appearances when possible.
        const fresh = queues.filter(queue => !recentSeries.includes(queue.key));
        const different = queues.filter(queue => queue.key !== recentSeries.at(-1));
        const candidates = fresh.length ? fresh : different.length ? different : queues;
        const target = rowTargets[(ordered.length / 4) % rowTargets.length];
        candidates.sort((a, b) => Math.abs(averagePrice(a.blocks[0]) - target) - Math.abs(averagePrice(b.blocks[0]) - target)
          || Number(a.blocks[0][0].dataset.seriesRank || 999) - Number(b.blocks[0][0].dataset.seriesRank || 999)
          || a.key.localeCompare(b.key));
        const next = candidates[0];
        ordered.push(...next.blocks.shift());
        recentSeries.push(next.key);
        if (recentSeries.length > 2) recentSeries.shift();
        if (!next.blocks.length) queues.splice(queues.indexOf(next), 1);
      }
      // Keep the remaining 1–3 pieces adjacent, pairing complementary group sizes
      // at the end rather than shifting every subsequent full row out of alignment.
      remainders.sort((a, b) => averagePrice(a) - averagePrice(b)
        || (a[0].dataset.series || '').localeCompare(b[0].dataset.series || ''));
      let rowSpace = 4;
      while (remainders.length) {
        let index = remainders.findIndex(group => group.length === rowSpace);
        if (index < 0) index = remainders.findIndex(group => group.length <= rowSpace);
        if (index < 0) index = 0;
        const group = remainders.splice(index, 1)[0];
        ordered.push(...group);
        rowSpace = (rowSpace - group.length + 4) % 4 || 4;
      }
      return ordered;
    };
    const arrangeCards = (value, selected) => {
      currentSort = value;
      const sorted = [...filterCards].sort((a, b) => {
        const byPrice = Number(a.dataset.price) - Number(b.dataset.price);
        const byTitle = a.dataset.title.localeCompare(b.dataset.title, collectionSection.dataset.locale || 'en');
        if (value === 'created-descending') {
          return Number(b.dataset.createdAt) - Number(a.dataset.createdAt) || byTitle || a.dataset.variantId.localeCompare(b.dataset.variantId);
        }
        if (value === 'manual') {
          return byPrice || byTitle || a.dataset.variantId.localeCompare(b.dataset.variantId);
        }
        return (value.startsWith('price-') ? (byPrice || byTitle) : (byTitle || byPrice))
          * (value.endsWith('descending') ? -1 : 1);
      });
      const matches = sorted.filter(card => cardMatchesSelection(card, selected));
      const excluded = sorted.filter(card => !cardMatchesSelection(card, selected));
      const ordered = value === 'manual' && !isSingleSeries ? arrangeRowGroups(matches) : matches;
      filterCards.splice(0, filterCards.length, ...ordered, ...excluded);
      filterCards.forEach(card => collectionGrid.appendChild(card));
    };
    let filterReturnFocus = null;
    let displayLimit = 24;
    const loadWrap = collectionSection.querySelector('[data-load-more-wrap]');
    const loadButton = collectionSection.querySelector('[data-load-more]');
    const loadProgress = collectionSection.querySelector('[data-load-progress]');

    const locale = collectionSection.dataset.locale || 'en';
    const currency = collectionSection.dataset.currency || 'USD';
    const uniquePrices = [...new Set(filterCards.map((card) => Number(card.dataset.price || 0)).filter((price) => price > 0))].sort((a, b) => a - b);
    const lowIndex = Math.floor(Math.max(0, uniquePrices.length - 1) / 3);
    const highIndex = Math.max(lowIndex + 1, Math.ceil((Math.max(0, uniquePrices.length - 1) * 2) / 3));
    const lowCeiling = uniquePrices[lowIndex] || 0;
    const highFloor = uniquePrices[Math.min(highIndex, Math.max(0, uniquePrices.length - 1))] || lowCeiling;
    const middleStart = uniquePrices.find((price) => price > lowCeiling) || highFloor;
    const middleEnd = [...uniquePrices].reverse().find((price) => price < highFloor) || middleStart;
    const formatPrice = (minorUnits) => new Intl.NumberFormat(locale, {
      style: 'currency',
      currency,
      minimumFractionDigits: 0,
      maximumFractionDigits: 1
    }).format(minorUnits / 100);

    collectionSection.querySelectorAll('[data-price-label]').forEach((label) => {
      const bucket = label.dataset.priceLabel;
      if (bucket === 'low') label.textContent = collectionSection.dataset.priceUpTo.replace('__AMOUNT__', formatPrice(lowCeiling));
      if (bucket === 'mid') label.textContent = `${formatPrice(middleStart)}–${formatPrice(middleEnd)}`;
      if (bucket === 'high') label.textContent = collectionSection.dataset.priceAndOver.replace('__AMOUNT__', formatPrice(highFloor));
    });

    const priceBucketMatches = (price, bucket) => {
      if (bucket === 'low') return price <= lowCeiling;
      if (bucket === 'mid') return price > lowCeiling && price < highFloor;
      return bucket === 'high' && price >= highFloor;
    };

    const cardMatchesValue = (card, group, value) => {
      if (group === 'price') return priceBucketMatches(Number(card.dataset.price || 0), value);
      if (group === 'color') return (card.dataset.color || '').split(',').includes(value);
      return card.dataset[group] === value;
    };

    const selectedFilters = () => filterInputs.reduce((selected, input) => {
      if (!input.checked) return selected;
      const group = input.dataset.filterGroup;
      selected[group] ||= [];
      selected[group].push(input.value);
      return selected;
    }, {});

    const cardMatchesSelection = (card, selected = selectedFilters()) => Object.entries(selected).every(([group, values]) => (
      values.some((value) => cardMatchesValue(card, group, value))
    ));

    const updateFilterButton = () => {
      if (!filterApply) return;
      const matchingCount = filterCards.filter((card) => cardMatchesSelection(card)).length;
      filterApply.textContent = collectionSection.dataset.showProducts.replace('__COUNT__', matchingCount);
    };

    const applyFilters = (resetLimit = true) => {
      if (resetLimit) displayLimit = 24;
      const selected = selectedFilters();
      if (resetLimit) arrangeCards(currentSort, selected);
      let visibleCount = 0;
      filterCards.forEach((card) => {
        const visible = cardMatchesSelection(card, selected);
        if (visible) visibleCount += 1;
        card.hidden = !visible || visibleCount > displayLimit;
      });

      const hasFilters = Object.keys(selected).length > 0;
      if (filterVisibleCount) {
        const displayedCount = visibleCount;
        const pieceOne = filterVisibleCount.dataset.pieceOne || 'piece';
        const pieceOther = filterVisibleCount.dataset.pieceOther || 'pieces';
        filterVisibleCount.textContent = `${displayedCount} ${displayedCount === 1 ? pieceOne : pieceOther}`;
      }
      if (filterEmpty) filterEmpty.hidden = visibleCount !== 0;
      if (loadWrap) loadWrap.hidden = visibleCount === 0;
      if (loadButton) loadButton.hidden = visibleCount <= displayLimit;
      if (loadProgress) loadProgress.textContent = collectionSection.dataset.progressLabel.replace('__SHOWN__', Math.min(displayLimit, visibleCount)).replace('__TOTAL__', visibleCount);
      filterClearButtons.forEach((button) => {
        if (button.classList.contains('bowbie-collection__clear-inline')) button.hidden = !hasFilters;
      });
      updateFilterButton();
    };

    const closeFilterDrawer = () => {
      if (!filterShell) return;
      filterShell.classList.remove('is-open');
      filterShell.setAttribute('aria-hidden', 'true');
      filterOpen?.setAttribute('aria-expanded', 'false');
      document.documentElement.classList.remove('plumimi-filter-open');
      filterReturnFocus?.focus({ preventScroll: true });
    };

    const openFilterDrawer = () => {
      if (!filterShell) return;
      filterReturnFocus = document.activeElement;
      filterShell.classList.add('is-open');
      filterShell.setAttribute('aria-hidden', 'false');
      filterOpen?.setAttribute('aria-expanded', 'true');
      document.documentElement.classList.add('plumimi-filter-open');
      updateFilterButton();
      window.requestAnimationFrame(() => filterShell.querySelector('[data-filter-close]:not(.bowbie-collection__filter-backdrop)')?.focus());
    };

    filterInputs.forEach((input) => {
      const group = input.dataset.filterGroup;
      const count = filterCards.filter((card) => cardMatchesValue(card, group, input.value)).length;
      const countLabel = collectionSection.querySelector(`[data-filter-count="${group}:${input.value}"]`);
      if (countLabel) countLabel.textContent = `(${count})`;
      if (count === 0) {
        input.disabled = true;
        const emptyOption = input.closest('label');
        emptyOption?.classList.add('is-disabled');
        if (emptyOption) emptyOption.hidden = true;
      }
      input.addEventListener('change', updateFilterButton);
    });

    filterOpen?.addEventListener('click', openFilterDrawer);
    filterShell?.querySelectorAll('[data-filter-close]').forEach((button) => button.addEventListener('click', closeFilterDrawer));
    filterApply?.addEventListener('click', () => {
      applyFilters();
      closeFilterDrawer();
    });
    filterClearButtons.forEach((button) => button.addEventListener('click', () => {
      filterInputs.forEach((input) => { input.checked = false; });
      applyFilters();
    }));

    loadButton?.addEventListener('click', () => {
      const previous = new Set(filterCards.filter(card => !card.hidden));
      displayLimit += 24;
      applyFilters(false);
      filterCards.find(card => !card.hidden && !previous.has(card))?.querySelector('a')?.focus({preventScroll:true});
    });

    const sortMenu = collectionSection.querySelector('[data-sort-menu]');
    sortMenu?.querySelectorAll('[data-sort-value]').forEach((button) => button.addEventListener('click', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', button.dataset.sortValue);
      url.searchParams.delete('page');
      const value = button.dataset.sortValue;
      currentSort = value;
      collectionSection.querySelector('[data-sort-label]').textContent = button.textContent;
      sortMenu.open = false;
      window.history.replaceState({}, '', url.toString());
      applyFilters();
      sortMenu.querySelector('summary')?.focus();
    }));

    document.addEventListener('click', (event) => {
      if (sortMenu?.open && !sortMenu.contains(event.target)) sortMenu.open = false;
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Tab' && filterShell?.classList.contains('is-open')) {
        const focusable = [...filterShell.querySelectorAll('button:not([disabled]),input:not([disabled]),summary,a[href]')].filter(el => el.getClientRects().length && !el.classList.contains('bowbie-collection__filter-backdrop'));
        const first = focusable[0], last = focusable[focusable.length - 1];
        if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last?.focus(); }
        else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first?.focus(); }
      }
      if (event.key !== 'Escape') return;
      if (filterShell?.classList.contains('is-open')) closeFilterDrawer();
      if (sortMenu?.open) sortMenu.open = false;
    });

    const initialSort = sortMenu?.querySelector(`[data-sort-value="${currentSort}"]`);
    if (initialSort) collectionSection.querySelector('[data-sort-label]').textContent = initialSort.textContent;
    applyFilters();

    const prepareCardImage = (image, priority = 'auto') => {
      if (!image) return null;
      if (priority === 'auto') image.fetchPriority = 'auto';
      if (image.dataset.plumimiSrc) {
        image.loading = 'eager';
        image.fetchPriority = priority;
        if (image.dataset.plumimiSrcset) image.srcset = image.dataset.plumimiSrcset;
        image.src = image.dataset.plumimiSrc;
        image.removeAttribute('data-plumimi-src');
        image.removeAttribute('data-plumimi-srcset');
      }
      return image;
    };
    const supportsHoverPreview = window.matchMedia('(hover: hover) and (pointer: fine)').matches;
    // Warm only the next image near the viewport; keep the rest of each gallery deferred.
    const hoverImageObserver = supportsHoverPreview && 'IntersectionObserver' in window
      ? new IntersectionObserver((entries, observer) => {
          entries.forEach((entry) => {
            if (!entry.isIntersecting) return;
            observer.unobserve(entry.target);
            const nextSlide = entry.target.querySelectorAll('.bowbie-product-card__slide')[1];
            const image = prepareCardImage(nextSlide?.querySelector('img'), 'low');
            if (image?.decode) image.decode().catch(() => {});
          });
        }, { rootMargin: '300px 0px' })
      : null;

    collectionSection.querySelectorAll('.bowbie-product-card').forEach((card) => {
      const slides = Array.from(card.querySelectorAll('.bowbie-product-card__slide'));
      const track = card.querySelector('[data-card-media-track]');
      const mediaSurface = card.querySelector('.bowbie-product-card__media');
      if (slides.length < 2) return;

      let activeIndex = 0;
      let hoverPreviewActive = false;
      let touchPreviewActive = false;
      let touchPreviewTimer = null;
      let touchBaseIndex = 0;
      let touchStartX = 0;
      let touchStartY = 0;
      let touchStartTime = 0;
      const prepareVideo = (slide) => {
        const video = slide?.querySelector('video');
        if (!video || video.dataset.cardPrepared === 'true') return;

        video.preload = 'auto';
        video.dataset.cardPrepared = 'true';
        video.load();
      };

      const showSlide = (nextIndex) => {
        activeIndex = (nextIndex + slides.length) % slides.length;
        const requestedIndex = activeIndex;
        const image = prepareCardImage(slides[requestedIndex].querySelector('img'));
        const revealSlide = () => {
          if (activeIndex !== requestedIndex) return;
          card.removeAttribute('aria-busy');
          track.style.transform = `translate3d(${-requestedIndex * 100}%, 0, 0)`;
          slides.forEach((slide, index) => {
          const isActive = index === requestedIndex;
          slide.classList.toggle('is-active', isActive);
          slide.setAttribute('aria-hidden', String(!isActive));
          slide.tabIndex = isActive ? 0 : -1;

          const video = slide.querySelector('video');
          if (!video) return;
          if (!isActive) {
            video.pause();
            return;
          }

          video.muted = true;
          const playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') {
            playPromise.catch(() => {});
          }
          });
        };
        if (image && !image.complete) {
          card.setAttribute('aria-busy', 'true');
          image.addEventListener('load', revealSlide, { once: true });
          image.addEventListener('error', () => {
            if (activeIndex === requestedIndex) card.removeAttribute('aria-busy');
          }, { once: true });
          return;
        }
        revealSlide();
      };

      const goToSlide = (nextIndex) => {
        hoverPreviewActive = false;
        touchPreviewActive = false;
        if (touchPreviewTimer) window.clearTimeout(touchPreviewTimer);
        touchPreviewTimer = null;
        const targetIndex = (nextIndex + slides.length) % slides.length;
        prepareVideo(slides[targetIndex]);
        showSlide(targetIndex);
      };

      const startTouchPreview = () => {
        if (touchPreviewActive || touchBaseIndex !== 0 || activeIndex !== 0) return;
        prepareVideo(slides[1]);
        showSlide(1);
        touchPreviewActive = true;
      };

      const endTouchPreview = () => {
        if (touchPreviewTimer) window.clearTimeout(touchPreviewTimer);
        touchPreviewTimer = null;
        if (!touchPreviewActive) return;
        touchPreviewActive = false;
        showSlide(touchBaseIndex);
      };

      card.querySelector('.bowbie-product-card__arrow--previous')?.addEventListener('click', () => goToSlide(activeIndex - 1));
      card.querySelector('.bowbie-product-card__arrow--next')?.addEventListener('click', () => goToSlide(activeIndex + 1));

      mediaSurface?.addEventListener('touchstart', (event) => {
        if (event.target.closest('.bowbie-product-card__arrow')) return;
        const touch = event.changedTouches[0];
        if (!touch) return;
        endTouchPreview();
        touchBaseIndex = activeIndex;
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        touchStartTime = Date.now();
        startTouchPreview();
      }, { passive: true });

      mediaSurface?.addEventListener('touchmove', (event) => {
        if (event.target.closest('.bowbie-product-card__arrow')) return;
        const touch = event.changedTouches[0];
        if (!touch) return;

        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;
        if (Math.abs(deltaX) > 14 && Math.abs(deltaX) > Math.abs(deltaY) * 1.2) {
          if (touchPreviewTimer) window.clearTimeout(touchPreviewTimer);
          touchPreviewTimer = null;
          return;
        }
        if (Math.abs(deltaY) > 8 && Math.abs(deltaY) > Math.abs(deltaX)) startTouchPreview();
      }, { passive: true });

      mediaSurface?.addEventListener('touchend', (event) => {
        if (event.target.closest('.bowbie-product-card__arrow')) return;
        if (touchPreviewTimer) window.clearTimeout(touchPreviewTimer);
        touchPreviewTimer = null;

        const touch = event.changedTouches[0];
        if (!touch) return;

        const deltaX = touch.clientX - touchStartX;
        const deltaY = touch.clientY - touchStartY;
        const elapsed = Date.now() - touchStartTime;
        const isHorizontalSwipe = Math.abs(deltaX) > 42 && Math.abs(deltaX) > Math.abs(deltaY) * 1.35 && elapsed < 900;
        if (!isHorizontalSwipe) {
          touchPreviewTimer = window.setTimeout(endTouchPreview, 1300);
          return;
        }

        event.preventDefault();
        goToSlide(deltaX < 0 ? touchBaseIndex + 1 : touchBaseIndex - 1);
      }, { passive: false });

      mediaSurface?.addEventListener('touchcancel', () => {
        if (touchPreviewTimer) window.clearTimeout(touchPreviewTimer);
        touchPreviewTimer = window.setTimeout(endTouchPreview, 1300);
      }, { passive: true });

      if (supportsHoverPreview) {
        hoverImageObserver?.observe(card);
        card.addEventListener('mouseenter', () => {
          if (activeIndex !== 0) return;
          prepareVideo(slides[1]);
          showSlide(1);
          hoverPreviewActive = true;
        });

        card.addEventListener('mouseleave', () => {
          if (!hoverPreviewActive) return;
          hoverPreviewActive = false;
          showSlide(0);
        });
      }
      showSlide(0);
    });

  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bowbie-global-header"] && !Shopify.designMode) return;
  try {
    
  function bowbieReplaceLegacyPolicyName() {
    var policy = document.querySelector('.shopify-policy__container');
    if (!policy) return;

    var walker = document.createTreeWalker(policy, NodeFilter.SHOW_TEXT);
    var nodes = [];
    var node;

    while ((node = walker.nextNode())) {
      nodes.push(node);
    }

    nodes.forEach(function(textNode) {
      textNode.nodeValue = textNode.nodeValue
        .replace(/Bearbear Express/g, 'Plumimi')
        .replace(/Bear Bear Express/g, 'Plumimi')
        .replace(/Bowbie Studio/g, 'Plumimi')
        .replace(/Bowbie/g, 'Plumimi')
        .replace(/The Matcha Tea Table/g, 'Plumimi First Drop')
        .replace(/Matcha Tea Table/g, 'Plumimi First Drop');
    });
  }

  bowbieReplaceLegacyPolicyName();

  var plumimiMobileMenu = document.querySelector('.bowbie-global-mobile-menu');

  if (plumimiMobileMenu) {
    var plumimiMobileMenuNav = plumimiMobileMenu.querySelector('nav');
    var plumimiMobileMenuClose = plumimiMobileMenu.querySelector('[data-plumimi-mobile-menu-close]');

    function plumimiCloseMobileMenu() {
      plumimiMobileMenu.removeAttribute('open');
      document.documentElement.classList.remove('plumimi-mobile-menu-open');
      plumimiMobileMenu.querySelector('summary').focus();
    }

    plumimiMobileMenu.addEventListener('toggle', function() {
      document.documentElement.classList.toggle('plumimi-mobile-menu-open', plumimiMobileMenu.open);
      if (plumimiMobileMenu.open && plumimiMobileMenuClose) plumimiMobileMenuClose.focus();
    });

    if (plumimiMobileMenuClose) {
      plumimiMobileMenuClose.addEventListener('click', plumimiCloseMobileMenu);
    }

    plumimiMobileMenu.addEventListener('click', function(event) {
      if (!plumimiMobileMenu.open || event.target.closest('summary') || event.target.closest('nav')) return;
      plumimiCloseMobileMenu();
    });

    if (plumimiMobileMenuNav) {
      plumimiMobileMenuNav.addEventListener('click', function(event) {
        if (event.target.closest('a')) plumimiCloseMobileMenu();
      });
    }

    document.addEventListener('keydown', function(event) {
      if (event.key === 'Escape' && plumimiMobileMenu.open) plumimiCloseMobileMenu();
      if (event.key !== 'Tab' || !plumimiMobileMenu.open || !plumimiMobileMenuNav) return;
      var stops = Array.from(plumimiMobileMenuNav.querySelectorAll('a,button,summary,select,input')).filter(function(node) { return !node.disabled && node.getClientRects().length; });
      if (!stops.length) return;
      var first = stops[0], last = stops[stops.length - 1];
      if (event.shiftKey && document.activeElement === first) { event.preventDefault(); last.focus(); }
      else if (!event.shiftKey && document.activeElement === last) { event.preventDefault(); first.focus(); }
    });
  }

  var plumimiDesktopMenus = Array.from(document.querySelectorAll('.pm-desktop-menu'));
  var plumimiDesktopLayout = window.matchMedia('(min-width: 1101px)');
  function plumimiPrepareMenuArt() {
    if (!plumimiDesktopLayout.matches) return;
    document.querySelectorAll('.pm-nav-panel img').forEach(function(image) { image.loading = 'eager'; });
  }
  plumimiPrepareMenuArt();
  function plumimiSetMenu(menu, open) {
    window.clearTimeout(menu.plumimiCloseTimer);
    menu.open = open;
    menu.querySelector('summary').setAttribute('aria-expanded', String(open));
    if (open) {
      menu.style.setProperty('--pm-nav-panel-top', menu.closest('.bowbie-global-header__inner').getBoundingClientRect().bottom + 'px');
      plumimiDesktopMenus.forEach(function(other) { if (other !== menu) plumimiSetMenu(other, false); });
    }
  }
  plumimiDesktopMenus.forEach(function(menu) {
    var summary = menu.querySelector('summary');
    menu.addEventListener('pointerenter', function(event) {
      if (plumimiDesktopLayout.matches && event.pointerType === 'mouse') plumimiSetMenu(menu, true);
    });
    menu.addEventListener('pointerleave', function(event) {
      if (event.pointerType !== 'mouse') return;
      window.clearTimeout(menu.plumimiCloseTimer);
      menu.plumimiCloseTimer = window.setTimeout(function() { plumimiSetMenu(menu, false); }, 220);
    });
    menu.addEventListener('toggle', function() {
      summary.setAttribute('aria-expanded', String(menu.open));
      if (menu.open) plumimiSetMenu(menu, true);
    });
    menu.addEventListener('focusin', function() { window.clearTimeout(menu.plumimiCloseTimer); });
    menu.addEventListener('click', function(event) {
      if (event.target.closest('.pm-nav-series-all')) plumimiSetMenu(menu, false);
    });
    menu.addEventListener('focusout', function() {
      window.setTimeout(function() { if (!menu.contains(document.activeElement)) plumimiSetMenu(menu, false); }, 0);
    });
    menu.addEventListener('keydown', function(event) {
      if (event.key === 'Escape') { event.preventDefault(); plumimiSetMenu(menu, false); summary.focus(); }
      if (event.key === 'ArrowDown' && event.target === summary) {
        event.preventDefault(); plumimiSetMenu(menu, true); menu.querySelector('.pm-nav-panel a').focus();
      }
    });
    document.addEventListener('click', function(event) { if (!menu.contains(event.target)) plumimiSetMenu(menu, false); });
  });
  plumimiDesktopLayout.addEventListener('change', function() {
    plumimiDesktopMenus.forEach(function(menu) { plumimiSetMenu(menu, false); });
    plumimiPrepareMenuArt();
  });

  var plumimiMegaMenus = document.querySelectorAll('[data-plumimi-mega]');
  var plumimiMegaReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  plumimiMegaMenus.forEach(function(megaMenu) {
    var showcase = megaMenu.querySelector('[data-plumimi-showcase]');
    var slides = Array.prototype.slice.call(megaMenu.querySelectorAll('[data-plumimi-showcase-slide]'));
    var targets = megaMenu.querySelectorAll('[data-plumimi-showcase-target]');
    var activeIndex = 0;
    var timer;

    if (!showcase || slides.length < 2) return;

    function showSlide(index) {
      activeIndex = (index + slides.length) % slides.length;
      slides.forEach(function(slide, slideIndex) {
        var isActive = slideIndex === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        slide.tabIndex = isActive ? 0 : -1;
      });
    }

    function showSlideByKey(key) {
      var index = slides.findIndex(function(slide) {
        return slide.dataset.plumimiShowcaseSlide === key;
      });
      if (index !== -1) showSlide(index);
    }

    function stopShowcase() {
      if (!timer) return;
      window.clearInterval(timer);
      timer = null;
    }

    function startShowcase() {
      if (plumimiMegaReducedMotion || timer) return;
      timer = window.setInterval(function() {
        showSlide(activeIndex + 1);
      }, 4500);
    }

    targets.forEach(function(target) {
      function selectTarget() {
        stopShowcase();
        showSlideByKey(target.dataset.plumimiShowcaseTarget);
        startShowcase();
      }
      target.addEventListener('mouseenter', selectTarget);
      target.addEventListener('focus', selectTarget);
    });

    showcase.addEventListener('mouseenter', stopShowcase);
    showcase.addEventListener('mouseleave', startShowcase);
    showcase.addEventListener('focusin', stopShowcase);
    showcase.addEventListener('focusout', function(event) {
      if (!showcase.contains(event.relatedTarget)) startShowcase();
    });

    showSlide(0);
    startShowcase();
  });

  var plumimiAnnouncement = document.querySelector('[data-plumimi-announcement]');

  if (plumimiAnnouncement) {
    var plumimiAnnouncementItems = Array.prototype.slice.call(plumimiAnnouncement.querySelectorAll('[data-plumimi-announcement-item]'));
    var plumimiAnnouncementIndex = 0;
    var plumimiAnnouncementTimer;
    var plumimiAnnouncementPrevious = plumimiAnnouncement.querySelector('[data-plumimi-announcement-previous]');
    var plumimiAnnouncementNext = plumimiAnnouncement.querySelector('[data-plumimi-announcement-next]');
    var plumimiReducedMotion = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function plumimiShowAnnouncement(index) {
      plumimiAnnouncementItems.forEach(function(item, itemIndex) {
        var active = itemIndex === index;
        item.classList.toggle('is-active', active);
        item.setAttribute('aria-hidden', String(!active));
        item.tabIndex = active ? 0 : -1;
      });
    }

    function plumimiStartAnnouncements() {
      if (plumimiReducedMotion || plumimiAnnouncementItems.length < 2 || plumimiAnnouncementTimer || plumimiAnnouncement.contains(document.activeElement)) return;
      plumimiAnnouncementTimer = window.setInterval(function() {
        plumimiAnnouncementIndex = (plumimiAnnouncementIndex + 1) % plumimiAnnouncementItems.length;
        plumimiShowAnnouncement(plumimiAnnouncementIndex);
      }, 5000);
    }

    function plumimiStopAnnouncements() {
      if (!plumimiAnnouncementTimer) return;
      window.clearInterval(plumimiAnnouncementTimer);
      plumimiAnnouncementTimer = null;
    }

    function plumimiStepAnnouncement(direction) {
      plumimiStopAnnouncements();
      plumimiAnnouncementIndex = (plumimiAnnouncementIndex + direction + plumimiAnnouncementItems.length) % plumimiAnnouncementItems.length;
      plumimiShowAnnouncement(plumimiAnnouncementIndex);
      plumimiStartAnnouncements();
    }

    if (plumimiAnnouncementPrevious) {
      plumimiAnnouncementPrevious.addEventListener('click', function() {
        plumimiStepAnnouncement(-1);
      });
    }

    if (plumimiAnnouncementNext) {
      plumimiAnnouncementNext.addEventListener('click', function() {
        plumimiStepAnnouncement(1);
      });
    }

    plumimiAnnouncement.addEventListener('mouseenter', plumimiStopAnnouncements);
    plumimiAnnouncement.addEventListener('mouseleave', plumimiStartAnnouncements);
    plumimiAnnouncement.addEventListener('focusin', plumimiStopAnnouncements);
    plumimiAnnouncement.addEventListener('focusout', function () { window.setTimeout(plumimiStartAnnouncements, 0); });
    plumimiShowAnnouncement(0);
    plumimiStartAnnouncements();
  }

  var plumimiNewsletterLinks = document.querySelectorAll('[data-plumimi-newsletter-link]');

  plumimiNewsletterLinks.forEach(function(link) {
    link.addEventListener('click', function(event) {
      if (!document.querySelector('[data-plumimi-newsletter-popup]')) return;
      event.preventDefault();
      document.dispatchEvent(new CustomEvent('plumimi:open-newsletter'));
    });
  });

  // Measure only when the header resizes, including translated copy and fonts.
  var plumimiGlobalHeader = document.querySelector('.bowbie-global-header');
  if (plumimiGlobalHeader) {
    var plumimiAnnouncement = plumimiGlobalHeader.querySelector('[data-plumimi-announcement]');
    function plumimiMeasureStickyHeader() {
      var announcementHeight = plumimiAnnouncement ? plumimiAnnouncement.offsetHeight : 0;
      document.documentElement.style.setProperty('--pm-announcement-height', announcementHeight + 'px');
      document.documentElement.style.setProperty('--pm-sticky-header-height', (plumimiGlobalHeader.offsetHeight - announcementHeight) + 'px');
    }
    plumimiMeasureStickyHeader();
    if ('ResizeObserver' in window) {
      var plumimiHeaderSizeObserver = new ResizeObserver(plumimiMeasureStickyHeader);
      plumimiHeaderSizeObserver.observe(plumimiGlobalHeader);
      if (plumimiAnnouncement) plumimiHeaderSizeObserver.observe(plumimiAnnouncement);
    } else {
      window.addEventListener('resize', plumimiMeasureStickyHeader, { passive: true });
    }
  }

  var plumimiHeader = document.querySelector('.bowbie-global-header--home');
  var plumimiHeaderScrollQueued = false;

  function plumimiSyncHeaderBackground() {
    if (!plumimiHeader) return;
    plumimiHeader.classList.toggle('is-scrolled', window.scrollY > 24);
    plumimiHeaderScrollQueued = false;
  }

  if (plumimiHeader) {
    window.addEventListener('scroll', function() {
      if (plumimiHeaderScrollQueued) return;
      plumimiHeaderScrollQueued = true;
      window.requestAnimationFrame(plumimiSyncHeaderBackground);
    }, { passive: true });
    plumimiSyncHeaderBackground();
  }

  var plumimiSearchDialog = document.querySelector('[data-plumimi-search-dialog]');
  var plumimiSearchOpen = document.querySelector('[data-plumimi-search-open]');
  var plumimiSearchClose = document.querySelector('[data-plumimi-search-close]');
  var plumimiSearchInput = document.querySelector('[data-plumimi-search-input]');
  var plumimiSearchProducts = document.querySelector('[data-plumimi-search-products]');
  var plumimiSearchProductsTitle = document.querySelector('[data-plumimi-search-products-title]');
  var plumimiSearchEmpty = document.querySelector('[data-plumimi-search-empty]');
  var plumimiSearchDefaultProducts = plumimiSearchProducts ? plumimiSearchProducts.innerHTML : '';
  var plumimiSearchTimer = null;
  var plumimiSearchController = null;
  var plumimiLocaleHeader = document.querySelector('[data-plumimi-locale-root]');
  var plumimiLocaleRoot = plumimiLocaleHeader ? plumimiLocaleHeader.dataset.plumimiLocaleRoot : '/';

  function plumimiUpdateCartBadge(itemCount) {
    var bag = document.querySelector('[data-plumimi-cart-bag]');
    if (!bag || typeof itemCount !== 'number') return;
    var count = bag.querySelector('[data-plumimi-cart-count]');
    if (!count) return;
    count.textContent = String(itemCount);
    count.hidden = itemCount < 1;
    var label = itemCount === 1 ? bag.dataset.bagLabelOne : bag.dataset.bagLabelOther;
    bag.setAttribute('aria-label', (label || '__COUNT__').replace('__COUNT__', String(itemCount)));
  }

  document.addEventListener('cart:update', function(event) {
    var detail = event.detail || {};
    var itemCount = detail.resource && detail.resource.item_count;
    if (typeof itemCount !== 'number' && detail.data) itemCount = detail.data.itemCount;
    if (typeof itemCount === 'number') plumimiUpdateCartBadge(itemCount);
  });

  function plumimiLocalePath(path) {
    if (!path) return plumimiLocaleRoot || '/';
    if (/^(?:[a-z]+:)?\/\//i.test(path) || path.charAt(0) === '#') return path;

    var root = plumimiLocaleRoot === '/' ? '' : plumimiLocaleRoot.replace(/\/$/, '');
    var normalizedPath = path.charAt(0) === '/' ? path : '/' + path;
    if (root && (normalizedPath === root || normalizedPath.indexOf(root + '/') === 0)) return normalizedPath;
    return root + normalizedPath;
  }

  function plumimiSearchProductCard(product) {
    var link = document.createElement('a');
    var imageWrap = document.createElement('span');
    var image = document.createElement('img');
    var title = document.createElement('span');
    var price = document.createElement('span');

    link.className = 'bowbie-global-search__product';
    link.href = plumimiLocalePath(product.url);
    imageWrap.className = 'bowbie-global-search__image';
    title.className = 'bowbie-global-search__product-title';
    price.className = 'bowbie-global-search__price';
    title.textContent = product.title;
    var amount = Number(product.price);
    var currency = plumimiSearchDialog && plumimiSearchDialog.dataset.currency || 'USD';
    if (Number.isFinite(amount)) {
      try {
        price.textContent = new Intl.NumberFormat(document.documentElement.lang || 'en', {
          style: 'currency',
          currency: currency
        }).format(amount);
      } catch (error) {
        price.textContent = product.price || '';
      }
    } else {
      price.textContent = product.price || '';
    }

    if (product.image && product.image.url) {
      image.src = product.image.url + (product.image.url.indexOf('?') === -1 ? '?width=560' : '&width=560');
      image.alt = product.image.alt || product.title;
      image.loading = 'eager';
      imageWrap.appendChild(image);
    }

    link.appendChild(imageWrap);
    link.appendChild(title);
    link.appendChild(price);
    return link;
  }

  function plumimiResetSearchSuggestions() {
    if (!plumimiSearchProducts) return;
    plumimiSearchProducts.innerHTML = plumimiSearchDefaultProducts;
    if (plumimiSearchProductsTitle) plumimiSearchProductsTitle.textContent = plumimiSearchDialog.dataset.popularTitle;
    if (plumimiSearchEmpty) plumimiSearchEmpty.hidden = true;
  }

  function plumimiLoadSearchSuggestions(query) {
    if (!plumimiSearchProducts) return;
    if (plumimiSearchController) plumimiSearchController.abort();
    plumimiSearchController = new AbortController();

    var predictiveSearchUrl = plumimiSearchDialog && plumimiSearchDialog.dataset.predictiveSearchUrl || plumimiLocalePath('/search/suggest');
    var suggestUrl = predictiveSearchUrl + '?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=4&resources[options][unavailable_products]=show';
    fetch(suggestUrl, {
      credentials: 'same-origin',
      headers: { 'accept': 'application/json' },
      signal: plumimiSearchController.signal
    }).then(function(response) {
      if (!response.ok) throw new Error('Search suggestions failed');
      return response.json();
    }).then(function(data) {
      var products = data && data.resources && data.resources.results && data.resources.results.products || [];
      plumimiSearchProducts.innerHTML = '';
      products.slice(0, 4).forEach(function(product) {
        plumimiSearchProducts.appendChild(plumimiSearchProductCard(product));
      });
      if (plumimiSearchProductsTitle) plumimiSearchProductsTitle.textContent = plumimiSearchDialog.dataset.suggestionsTitle;
      if (plumimiSearchEmpty) plumimiSearchEmpty.hidden = products.length > 0;
    }).catch(function(error) {
      if (error.name !== 'AbortError') plumimiResetSearchSuggestions();
    });
  }

  if (plumimiSearchDialog && plumimiSearchOpen) {
    plumimiSearchOpen.addEventListener('click', function() {
      if (!plumimiSearchDialog.open) plumimiSearchDialog.showModal();
      document.documentElement.classList.add('plumimi-search-open');
      window.requestAnimationFrame(function() {
        if (plumimiSearchInput) plumimiSearchInput.focus({ preventScroll: true });
      });
    });

    plumimiSearchDialog.addEventListener('close', function() {
      document.documentElement.classList.remove('plumimi-search-open');
      plumimiSearchOpen.focus({ preventScroll: true });
    });

    plumimiSearchDialog.addEventListener('click', function(event) {
      if (event.target === plumimiSearchDialog) plumimiSearchDialog.close();
    });
  }

  if (plumimiSearchDialog && plumimiSearchClose) {
    plumimiSearchClose.addEventListener('click', function() {
      plumimiSearchDialog.close();
    });
  }

  if (plumimiSearchInput) {
    plumimiSearchInput.addEventListener('input', function() {
      var query = plumimiSearchInput.value.trim();
      window.clearTimeout(plumimiSearchTimer);
      if (query.length < 2) {
        if (plumimiSearchController) plumimiSearchController.abort();
        plumimiResetSearchSuggestions();
        return;
      }
      plumimiSearchTimer = window.setTimeout(function() {
        plumimiLoadSearchSuggestions(query);
      }, 180);
    });
  }

  function plumimiWishlistRequest(options) {
    return fetch('/apps/plumimi-wishlist/wishlist', Object.assign({
      credentials: 'same-origin',
      headers: { 'accept': 'application/json' }
    }, options || {})).then(function(response) {
      if (response.status === 401) return { items: [] };
      if (!response.ok) throw new Error('Wishlist request failed');
      return response.json();
    }).catch(function() {
      return { items: [] };
    });
  }

  function plumimiWishlistProductJson(handle) {
    if (!handle) return Promise.resolve(null);
    return fetch('/products/' + encodeURIComponent(handle) + '.js', {
      credentials: 'same-origin',
      headers: { 'accept': 'application/json' }
    }).then(function(response) {
      if (!response.ok) return null;
      return response.json();
    }).catch(function() {
      return null;
    });
  }

  function plumimiWishlistNormalizeImageUrl(url) {
    if (!url) return '';
    if (url.indexOf('//') === 0) return window.location.protocol + url;
    return url;
  }

  function plumimiWishlistRenderImage(imageLink, item, productUrl) {
    function appendImage(src, title) {
      var imageUrl = plumimiWishlistNormalizeImageUrl(src);
      if (!imageUrl) return false;

      var image = document.createElement('img');
      image.src = imageUrl;
      image.alt = title || item.title || '';
      image.loading = 'lazy';
      image.width = 208;
      image.height = 208;
      imageLink.replaceChildren(image);
      return true;
    }

    if (appendImage(item.imageUrl, item.title)) return;

    plumimiWishlistProductJson(item.handle).then(function(product) {
      if (!product) return;
      appendImage(product.featured_image || (product.images && product.images[0]), product.title);
    });
  }

  function plumimiRenderWishlist() {
    var count = document.querySelector('[data-plumimi-wishlist-count]');
    var container = document.querySelector('[data-plumimi-wishlist-items]');

    return plumimiWishlistRequest().then(function(data) {
      var list = Array.isArray(data.items) ? data.items : [];

      if (count) {
        count.textContent = String(list.length);
        count.hidden = list.length === 0;
      }

      if (!container) return;
      container.replaceChildren();

      if (list.length === 0) {
        var empty = document.createElement('p');
        empty.className = 'bowbie-global-wishlist__empty';
        empty.textContent = 'Your wishlist is empty.';
        container.appendChild(empty);
        return;
      }

      var items = document.createElement('ul');
      items.className = 'bowbie-global-wishlist__list';

      list.forEach(function(item) {
        var row = document.createElement('li');
        var productUrl = plumimiLocalePath('/products/' + item.handle);
        var imageLink = document.createElement('a');
        var content = document.createElement('div');
        var titleLink = document.createElement('a');
        var price = document.createElement('p');
        var actions = document.createElement('div');
        var view = document.createElement('a');
        var remove = document.createElement('button');

        imageLink.className = 'bowbie-global-wishlist__image';
        imageLink.href = productUrl;
        imageLink.setAttribute('aria-label', 'View ' + (item.title || item.handle));
        content.className = 'bowbie-global-wishlist__content';
        titleLink.className = 'bowbie-global-wishlist__title';
        titleLink.href = productUrl;
        titleLink.textContent = item.title || item.handle;
        price.className = 'bowbie-global-wishlist__price';
        price.textContent = item.priceText || '';
        actions.className = 'bowbie-global-wishlist__actions';
        view.className = 'bowbie-global-wishlist__view';
        view.href = productUrl;
        view.textContent = 'View product';
        remove.type = 'button';
        remove.className = 'bowbie-global-wishlist__remove';
        remove.dataset.wishlistProductId = item.productId;
        remove.textContent = 'Remove';
        actions.append(view, remove);
        content.append(titleLink, price, actions);
        row.append(imageLink, content);
        items.appendChild(row);

        plumimiWishlistRenderImage(imageLink, item, productUrl);
      });

      container.appendChild(items);
    });
  }

  var plumimiWishlistDialog = document.querySelector('[data-plumimi-wishlist-dialog]');
  var plumimiWishlistOpen = document.querySelectorAll('[data-plumimi-wishlist-open]');
  var plumimiWishlistClose = document.querySelector('[data-plumimi-wishlist-close]');

  if (plumimiWishlistDialog) {
    plumimiWishlistOpen.forEach(function(trigger) { trigger.addEventListener('click', function() {
      if (plumimiMobileMenu && plumimiMobileMenu.open) plumimiCloseMobileMenu();
      plumimiRenderWishlist();
      plumimiWishlistDialog.showModal();
    }); });
  }

  if (plumimiWishlistClose && plumimiWishlistDialog) {
    plumimiWishlistClose.addEventListener('click', function() {
      plumimiWishlistDialog.close();
    });

    plumimiWishlistDialog.addEventListener('click', function(event) {
      if (event.target === plumimiWishlistDialog) plumimiWishlistDialog.close();
    });

    plumimiWishlistDialog.addEventListener('click', function(event) {
      var remove = event.target.closest('[data-wishlist-handle]');
      if (!remove) remove = event.target.closest('[data-wishlist-product-id]');
      if (!remove) return;

      remove.disabled = true;
      plumimiWishlistRequest({
        method: 'POST',
        headers: {
          'accept': 'application/json',
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          action: 'remove',
          productId: remove.dataset.wishlistProductId
        })
      }).then(function() {
        return plumimiRenderWishlist();
      }).then(function() {
        document.dispatchEvent(new CustomEvent('plumimi:wishlist-change'));
      });
    });
  }

  document.addEventListener('plumimi:wishlist-change', plumimiRenderWishlist);
  plumimiRenderWishlist();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bowbie-product-main"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.plumimi-product-main__express[data-more-payment-label]').forEach(function(expressCheckout) {
    var preferredLabel = expressCheckout.dataset.morePaymentLabel;
    var observer;

    function updateMorePaymentLabel() {
      var morePaymentLink = expressCheckout.querySelector('.shopify-payment-button__more-options, more-payment-options-link a');
      if (!morePaymentLink) return false;
      morePaymentLink.textContent = preferredLabel;
      return true;
    }

    if (!updateMorePaymentLabel()) {
      observer = new MutationObserver(function() {
        if (updateMorePaymentLabel()) observer.disconnect();
      });
      observer.observe(expressCheckout, { childList: true, subtree: true });
      window.setTimeout(function() { if (observer) observer.disconnect(); }, 8000);
    }
  });

  document.querySelectorAll('[data-plumimi-product-gallery]').forEach(function(gallery) {
    var section = gallery.closest('.plumimi-product-main');
    var track = gallery.querySelector('[data-plumimi-gallery-track]');
    var prevButton = gallery.querySelector('[data-plumimi-gallery-prev]');
    var nextButton = gallery.querySelector('[data-plumimi-gallery-next]');
    if (!track || !prevButton || !nextButton) return;
    var slides = Array.from(track.querySelectorAll('.plumimi-product-main__media'));
    if (!slides.length) return;
    var thumbnails = Array.from(gallery.querySelectorAll('[data-plumimi-gallery-thumbnail]'));
    var thumbnailGrid = gallery.querySelector('.plumimi-product-main__thumbnails');
    var counter = gallery.querySelector('[data-pm-media-count]');
    var caption = gallery.querySelector('[data-pm-media-caption]');
    var labels = gallery.dataset.imageLabel;
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)');
    var zoomLayout = window.matchMedia('(min-width: 900px) and (hover: hover) and (pointer: fine)');
    var mapNode = gallery.querySelector('[data-pm-gallery-map]');
    var membership = mapNode ? JSON.parse(mapNode.textContent) : {};
    var selectedVariant = gallery.dataset.variantId;
    var variantOptions = Array.from(section.querySelectorAll('[data-plumimi-variant-select] option'));
    var variantNames = {};
    variantOptions.forEach(function(option) { variantNames[option.value] = option.dataset.variantTitle; });
    var visibleSlides = [];
    var activeIndex = 0;
    var resizeFrame;
    var lightbox = section.querySelector('[data-plumimi-product-lightbox]');
    var expandedSlides = lightbox ? Array.from(lightbox.querySelectorAll('[data-plumimi-lightbox-slide]')) : [];
    var expandedThumbs = lightbox ? Array.from(lightbox.querySelectorAll('[data-plumimi-lightbox-thumbnail]')) : [];
    var expandedPrevious = lightbox && lightbox.querySelector('[data-plumimi-lightbox-prev]');
    var expandedNext = lightbox && lightbox.querySelector('[data-plumimi-lightbox-next]');
    var expandedIndex = 0;
    var expandedTrigger;
    var expandedCaption = lightbox && lightbox.querySelector('[data-pm-expanded-caption]');

    function resetZoom() {
      slides.forEach(function(slide) {
        slide.classList.remove('is-inline-zoom-active');
        var image = slide.querySelector('.plumimi-product-main__image');
        if (image) image.style.transformOrigin = '50% 50%';
      });
    }

    function pauseMedia(slide) {
      slide.querySelectorAll('video').forEach(function(video) { video.pause(); });
    }

    function preparePhoto(slide) {
      if (!slide || slide.dataset.previewGroup === 'styled') return;
      var image = slide.querySelector('.plumimi-product-main__image');
      if (!image) return;
      var frame = slide.getBoundingClientRect();
      var width = Number(slide.dataset.imageWidth);
      var height = Number(slide.dataset.imageHeight);
      var photoStyle = getComputedStyle(image);
      var baseScale = parseFloat(photoStyle.getPropertyValue('--plumimi-subject-scale')) || 1;
      var renderedWidth = photoStyle.objectFit === 'cover'
        ? Math.max(frame.width, frame.height * width / height)
        : Math.min(frame.width, frame.height * width / height);
      var scale = width && renderedWidth ? Math.min(baseScale, width * 1.25 / renderedWidth) : baseScale;
      image.style.setProperty('--pm-effective-scale', scale.toFixed(5));
      ['x', 'y'].forEach(function(axis) {
        var offset = parseFloat(photoStyle.getPropertyValue('--plumimi-subject-' + axis)) || 0;
        image.style.setProperty('--pm-effective-' + axis, (offset * scale / baseScale).toFixed(4) + '%');
      });
      var detailWidth = Math.ceil(renderedWidth * Math.min(scale, 1.15) * 2.15);
      var sizes = Math.min(width || 1800, detailWidth, 1800) + 'px';
      if (image.sizes !== sizes) image.sizes = sizes;
      var usableZoom = width && renderedWidth ? width / (renderedWidth * scale) : 2.15;
      slide.style.setProperty('--pm-photo-zoom', Math.max(1, Math.min(2.15, usableZoom)).toFixed(3));
    }

    function imageLabel(index) {
      return labels.replace('__CURRENT__', index + 1).replace('__TOTAL__', visibleSlides.length);
    }

    function variantMediaIds(variantId) {
      var groups = membership.variants && membership.variants[variantId];
      return groups ? ['styled', 'details', 'real'].flatMap(function(group) { return groups[group] || []; }) : [];
    }

    function mediaCaption(slide) {
      if (!slide || variantOptions.length <= 1) return '';
      var owners = variantOptions.filter(function(option) {
        return variantMediaIds(option.value).includes(slide.dataset.mediaId)
          || option.dataset.mediaId === slide.dataset.mediaId;
      });
      var names = owners.map(function(option) { return variantNames[option.value]; }).filter(Boolean);
      if (!names.length) return '';
      var shown = owners.length === variantOptions.length ? gallery.dataset.sharedLabel : names.join(' / ');
      return gallery.dataset.shownLabel.replace('__OPTION__', shown);
    }

    function currentIndex() {
      var width = visibleSlides[0] && visibleSlides[0].getBoundingClientRect().width;
      return width ? Math.max(0, Math.min(visibleSlides.length - 1, Math.round(track.scrollLeft / width))) : 0;
    }

    function updateButtons() {
      activeIndex = currentIndex();
      prevButton.disabled = activeIndex <= 0;
      nextButton.disabled = activeIndex >= visibleSlides.length - 1;
      prevButton.hidden = nextButton.hidden = visibleSlides.length <= 1;
      var active = visibleSlides[activeIndex];
      if (caption) {
        caption.textContent = mediaCaption(active);
        caption.hidden = !caption.textContent;
      }
      thumbnails.forEach(function(button) {
        var isCurrent = !!active && button.dataset.mediaIndex === active.dataset.mediaIndex;
        var becameCurrent = isCurrent && button.getAttribute('aria-current') !== 'true';
        button.setAttribute('aria-current', String(isCurrent));
        if (becameCurrent && thumbnailGrid) {
          var stripBounds = thumbnailGrid.getBoundingClientRect();
          var buttonBounds = button.getBoundingClientRect();
          if (buttonBounds.left < stripBounds.left || buttonBounds.right > stripBounds.right) {
            thumbnailGrid.scrollTo({
              left: thumbnailGrid.scrollLeft + buttonBounds.left - stripBounds.left - (thumbnailGrid.clientWidth - buttonBounds.width) / 2,
              behavior: reduceMotion.matches ? 'instant' : 'smooth'
            });
          }
        }
      });
      if (counter) {
        counter.textContent = (visibleSlides.length ? activeIndex + 1 : 0) + ' / ' + visibleSlides.length;
        counter.setAttribute('aria-label', imageLabel(activeIndex));
      }
      slides.forEach(function(slide) {
        if (slide.hasAttribute('data-plumimi-expand-surface')) slide.tabIndex = slide === active ? 0 : -1;
        slide.querySelectorAll('video').forEach(function(video) {
          if (slide === active) {
            var play = video.play();
            if (play && play.catch) play.catch(function() {});
          } else video.pause();
        });
      });
    }

    function scrollToIndex(index, instant) {
      var next = Math.max(0, Math.min(visibleSlides.length - 1, index));
      if (!visibleSlides[next]) return;
      resetZoom();
      activeIndex = next;
      preparePhoto(visibleSlides[next]);
      track.scrollTo({ left: next * visibleSlides[0].getBoundingClientRect().width, behavior: instant || reduceMotion.matches ? 'instant' : 'smooth' });
      updateButtons();
    }

    function showExpanded(index) {
      if (!lightbox || !visibleSlides.length) return;
      expandedIndex = Math.max(0, Math.min(visibleSlides.length - 1, index));
      var activeGlobal = visibleSlides[expandedIndex].dataset.mediaIndex;
      if (expandedCaption) expandedCaption.textContent = (mediaCaption(visibleSlides[expandedIndex]) || expandedCaption.dataset.productTitle) + ' · ' + (expandedIndex + 1) + ' / ' + visibleSlides.length;
      expandedSlides.forEach(function(slide) {
        slide.hidden = slide.dataset.mediaIndex !== activeGlobal;
        if (slide.hidden) pauseMedia(slide);
      });
      expandedThumbs.forEach(function(button) {
        var localIndex = visibleSlides.findIndex(function(slide) { return slide.dataset.mediaIndex === button.dataset.mediaIndex; });
        button.hidden = localIndex < 0;
        button.setAttribute('aria-current', String(button.dataset.mediaIndex === activeGlobal));
        if (localIndex >= 0) button.setAttribute('aria-label', imageLabel(localIndex) + (button.title ? ' · ' + button.title : ''));
      });
      expandedPrevious.hidden = expandedNext.hidden = visibleSlides.length <= 1;
      expandedPrevious.disabled = expandedIndex <= 0;
      expandedNext.disabled = expandedIndex >= visibleSlides.length - 1;
    }

    function showVariant(mediaId) {
      gallery.dataset.variantId = selectedVariant;
      var ids = variantMediaIds(selectedVariant);
      var preferred = ids.find(function(id) { return visibleSlides.some(function(slide) { return slide.dataset.mediaId === id; }); }) || mediaId;
      var index = visibleSlides.findIndex(function(slide) { return slide.dataset.mediaId === preferred; });
      if (index < 0) index = 0;
      scrollToIndex(index, true);
      if (lightbox && lightbox.open) showExpanded(index);
    }

    var orderedIds = [];
    var variantOrder = variantOptions.length ? variantOptions.map(function(option) { return option.value; }) : Object.keys(membership.variants || {});
    var groupOrder = ['styled', 'details', 'real'];
    var idsByGroup = {styled: [], details: [], real: []};
    var mediaGroup = new Map();
    groupOrder.forEach(function(group) {
      variantOrder.forEach(function(variantId) {
        var groups = membership.variants && membership.variants[variantId];
        (groups && groups[group] || []).forEach(function(id) {
          if (mediaGroup.has(id)) return;
          mediaGroup.set(id, group);
          idsByGroup[group].push(id);
        });
      });
    });
    // Keep new or unmapped media in the gallery rather than losing it.
    slides.forEach(function(slide) {
      var id = slide.dataset.mediaId;
      if (mediaGroup.has(id)) return;
      var image = slide.querySelector('img');
      var alt = image ? image.alt.toLowerCase() : '';
      var group = /hand-painted illustration|real product photo$/.test(alt) ? 'styled' : /isolated|product.only|cutout/.test(alt) ? 'details' : 'real';
      mediaGroup.set(id, group);
      idsByGroup[group].push(id);
    });
    groupOrder.forEach(function(group) {
      idsByGroup[group] = idsByGroup[group].filter(function(id) { return slides.some(function(slide) { return slide.dataset.mediaId === id; }); });
      orderedIds.push.apply(orderedIds, idsByGroup[group]);
    });
    Array.from(new Set(orderedIds)).forEach(function(id) {
      var slide = slides.find(function(item) { return item.dataset.mediaId === id; });
      if (!slide) return;
      var group = mediaGroup.get(id);
      visibleSlides.push(slide);
      slide.hidden = false;
      slide.dataset.previewGroup = group;
      var expandedSlide = expandedSlides.find(function(item) { return item.dataset.mediaIndex === slide.dataset.mediaIndex; });
      if (expandedSlide) expandedSlide.dataset.previewGroup = group;
      track.appendChild(slide);
      [thumbnails, expandedThumbs].forEach(function(buttons) {
        var button = buttons.find(function(item) { return item.dataset.mediaId === id || item.dataset.mediaIndex === slide.dataset.mediaIndex; });
        if (!button) return;
        button.hidden = false;
        button.dataset.previewGroup = group;
        var shown = mediaCaption(slide);
        button.title = shown;
        button.parentNode.appendChild(button);
      });
    });
    [thumbnails, expandedThumbs].forEach(function(buttons) {
      buttons.forEach(function(button) {
        var index = visibleSlides.findIndex(function(slide) { return slide.dataset.mediaIndex === button.dataset.mediaIndex; });
        if (index >= 0) button.setAttribute('aria-label', imageLabel(index) + (button.title ? ' · ' + button.title : ''));
      });
    });
    gallery.classList.add('pm-gallery-ready');

    gallery.addEventListener('plumimi:show-media', function(event) {
      if (event.detail && event.detail.variantId) {
        selectedVariant = String(event.detail.variantId);
        showVariant(String(event.detail.mediaId || ''));
      }
    });
    prevButton.addEventListener('click', function() { scrollToIndex(currentIndex() - 1); });
    nextButton.addEventListener('click', function() { scrollToIndex(currentIndex() + 1); });
    thumbnails.forEach(function(button) {
      button.addEventListener('click', function() {
        var index = visibleSlides.findIndex(function(slide) { return slide.dataset.mediaIndex === button.dataset.mediaIndex; });
        if (index >= 0) scrollToIndex(index);
      });
    });
    track.addEventListener('scroll', function() { resetZoom(); window.requestAnimationFrame(updateButtons); }, {passive: true});
    track.addEventListener('scrollend', function() { preparePhoto(visibleSlides[currentIndex()]); }, {passive: true});
    window.addEventListener('resize', function() {
      window.cancelAnimationFrame(resizeFrame);
      resizeFrame = window.requestAnimationFrame(function() { scrollToIndex(activeIndex, true); });
    }, {passive: true});
    zoomLayout.addEventListener('change', resetZoom);

    slides.forEach(function(surface) {
      var image = surface.querySelector('.plumimi-product-main__image');
      if (!image || !surface.hasAttribute('data-plumimi-expand-surface')) return;
      surface.addEventListener('pointerenter', function() { preparePhoto(surface); });
      surface.addEventListener('pointermove', function(event) {
        var bounds = surface.getBoundingClientRect();
        var pointerX = event.clientX - bounds.left;
        var arrowLane = Math.min(88, bounds.width * .22);
        if (!zoomLayout.matches || event.pointerType === 'touch' || pointerX <= arrowLane || pointerX >= bounds.width - arrowLane) {
          resetZoom();
          return;
        }
        var x = Math.max(0, Math.min(100, pointerX / bounds.width * 100));
        var y = Math.max(0, Math.min(100, (event.clientY - bounds.top) / bounds.height * 100));
        image.style.transformOrigin = x.toFixed(2) + '% ' + y.toFixed(2) + '%';
        surface.classList.add('is-inline-zoom-active');
      });
      surface.addEventListener('pointerleave', resetZoom);
      function expand() {
        if (!lightbox) return;
        var index = visibleSlides.indexOf(surface);
        if (index < 0) return;
        resetZoom();
        expandedTrigger = surface;
        showExpanded(index);
        lightbox.showModal();
        document.documentElement.style.overflow = 'hidden';
      }
      surface.addEventListener('click', expand);
      surface.addEventListener('keydown', function(event) {
        if (event.key === 'Enter' || event.key === ' ') { event.preventDefault(); expand(); }
      });
    });
    if (lightbox) {
      lightbox.querySelector('[data-plumimi-lightbox-close]').addEventListener('click', function() { lightbox.close(); });
      expandedPrevious.addEventListener('click', function() { showExpanded(expandedIndex - 1); });
      expandedNext.addEventListener('click', function() { showExpanded(expandedIndex + 1); });
      expandedThumbs.forEach(function(button) {
        button.addEventListener('click', function() {
          var index = visibleSlides.findIndex(function(slide) { return slide.dataset.mediaIndex === button.dataset.mediaIndex; });
          if (index >= 0) showExpanded(index);
        });
      });
      lightbox.addEventListener('click', function(event) { if (event.target === lightbox) lightbox.close(); });
      lightbox.addEventListener('close', function() {
        document.documentElement.style.overflow = '';
        expandedSlides.forEach(pauseMedia);
        scrollToIndex(expandedIndex, true);
        var returnSurface = visibleSlides[expandedIndex] || expandedTrigger;
        if (returnSurface) returnSurface.focus({preventScroll: true});
      });
      lightbox.addEventListener('keydown', function(event) {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          showExpanded(expandedIndex + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
    }
    var initialVariantOption = variantOptions.find(function(option) { return option.value === selectedVariant; });
    showVariant(initialVariantOption && initialVariantOption.dataset.mediaId);
  });


  document.querySelectorAll('[data-plumimi-video-sound]').forEach(function(button) {
    var media = button.closest('.plumimi-product-main__media');
    var video = media && media.querySelector('video');

    if (!video) {
      button.hidden = true;
      return;
    }

    function syncLabel() {
      button.dataset.sound = video.muted ? 'off' : 'on';
      button.setAttribute('aria-label', video.muted ? 'Turn video sound on' : 'Turn video sound off');
    }

    button.addEventListener('click', function() {
      video.muted = !video.muted;
      if (!video.paused) {
        syncLabel();
        return;
      }

      var playPromise = video.play();
      if (playPromise && typeof playPromise.catch === 'function') {
        playPromise.catch(function() {});
      }
      syncLabel();
    });

    syncLabel();
  });

  document.querySelectorAll('.plumimi-product-main__form').forEach(function(form) {
    var select = form.querySelector('[data-plumimi-variant-select]');
    var variantButtons = form.querySelectorAll('[data-plumimi-variant-option]');
    var productSection = form.closest('.plumimi-product-main');
    var gallery = productSection && productSection.querySelector('[data-plumimi-product-gallery]');
    var addButton = form.querySelector('.plumimi-product-main__add');
    var price = productSection && productSection.querySelector('[data-plumimi-product-price]');
    var rewardPoints = productSection && productSection.querySelector('[data-plumimi-product-reward-points]');
    var originalAddText = addButton && addButton.dataset.addText;

    if (!addButton) return;

    if (select) {
      select.addEventListener('change', function() {
        var option = select.options[select.selectedIndex];
        var available = option && option.dataset.available === 'true';
        var unavailableText = (option && option.dataset.unavailableText) || addButton.dataset.soldoutText;

        variantButtons.forEach(function(button) {
          var isSelected = button.dataset.variantId === select.value;
          button.classList.toggle('is-selected', isSelected);
          button.setAttribute('aria-checked', isSelected ? 'true' : 'false');
        });

        if (price && option && option.dataset.price) {
          price.textContent = option.dataset.price;
        }

        if (rewardPoints && option && option.dataset.rewardPoints) {
          rewardPoints.textContent = option.dataset.rewardPoints;
        }

        addButton.disabled = !available;
        addButton.classList.remove('is-added', 'is-loading');
        addButton.textContent = available ? addButton.dataset.addText : unavailableText;

        if (gallery && option && option.dataset.mediaId) {
          gallery.dispatchEvent(new CustomEvent('plumimi:show-media', {
            detail: { variantId: select.value, mediaId: option.dataset.mediaId }
          }));
        }
        var selectedUrl = new URL(window.location.href);
        selectedUrl.searchParams.set('variant', select.value);
        window.history.replaceState({}, '', selectedUrl.toString());
      });

      variantButtons.forEach(function(button) {
        button.addEventListener('click', function() {
          if (button.disabled || button.dataset.variantId === select.value) {
            if (!button.disabled) select.dispatchEvent(new Event('change', { bubbles: true }));
            return;
          }

          select.value = button.dataset.variantId;
          select.dispatchEvent(new Event('change', { bubbles: true }));
        });
      });
      var initialOption = select.options[select.selectedIndex];
      if (gallery && initialOption && initialOption.dataset.mediaId) {
        gallery.dispatchEvent(new CustomEvent('plumimi:show-media', {
          detail: { variantId: select.value, mediaId: initialOption.dataset.mediaId, behavior: 'instant' }
        }));
      }
    }

    form.addEventListener('submit', function(event) {
      if (form.dataset.plumimiSubmitting === 'true') return;
      if (event.submitter && event.submitter !== addButton) return;

      event.preventDefault();
      addButton.disabled = true;
      addButton.classList.remove('is-added');
      addButton.classList.add('is-loading');
      addButton.textContent = addButton.dataset.addingText;
      form.dataset.plumimiSubmitting = 'true';

      var previousError = form.querySelector('.plumimi-product-main__form-error');
      if (previousError) previousError.remove();

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'accept': 'application/json' },
        body: new FormData(form)
      }).then(function(response) {
        return response.json().then(function(data) {
          if (!response.ok) throw new Error(data.description || 'Unable to add this item.');
          return data;
        });
      }).then(function() {
        addButton.classList.remove('is-loading');
        addButton.classList.add('is-added');
        addButton.textContent = addButton.dataset.addedText;
        return fetch('/cart.js', { headers: { 'accept': 'application/json' } });
      }).then(function(response) {
        if (!response.ok) return null;
        return response.json();
      }).then(function(cart) {
        if (!cart) return;
        var bag = document.querySelector('.bowbie-global-tool--bag');
        if (!bag) return;
        var count = bag.querySelector('.bowbie-global-tool__count');
        if (!count) {
          count = document.createElement('span');
          count.className = 'bowbie-global-tool__count';
          bag.appendChild(count);
        }
        count.textContent = cart.item_count;
        count.hidden = cart.item_count < 1;
        var labelTemplate = cart.item_count === 1 ? bag.dataset.bagLabelOne : bag.dataset.bagLabelOther;
        labelTemplate = labelTemplate || 'Shopping bag, __COUNT__ items';
        bag.setAttribute('aria-label', labelTemplate.replace('__COUNT__', String(cart.item_count)));
        sessionStorage.setItem('cart-count', String(cart.item_count));
      }).catch(function(error) {
        addButton.classList.remove('is-loading', 'is-added');
        addButton.textContent = originalAddText;
        var errorMessage = document.createElement('p');
        errorMessage.className = 'plumimi-product-main__form-error';
        errorMessage.setAttribute('role', 'alert');
        errorMessage.textContent = error.message || addButton.dataset.errorText;
        form.appendChild(errorMessage);
      }).finally(function() {
        addButton.disabled = false;
        form.dataset.plumimiSubmitting = 'false';
      });
    });
  });

  document.querySelectorAll('[data-plumimi-wishlist]').forEach(function(button) {
    var productId = button.dataset.productId;
    var endpoint = '/apps/plumimi-wishlist/wishlist';
    var productSection = button.closest('.plumimi-product-main');
    var accountLoginUrl = productSection ? productSection.dataset.accountLoginUrl : '';

    if (!productId) return;

    function setSaved(saved) {
      button.setAttribute('aria-pressed', saved ? 'true' : 'false');
      button.textContent = saved ? button.dataset.labelSaved : button.dataset.labelAdd;
    }

    function setBusy(busy) {
      button.disabled = busy;
      button.setAttribute('aria-busy', busy ? 'true' : 'false');
    }

    function requestWishlist(options) {
      return fetch(endpoint, Object.assign({
        credentials: 'same-origin',
        headers: { 'accept': 'application/json' }
      }, options || {})).then(function(response) {
        if (response.status === 401) {
          if (accountLoginUrl) window.location.href = accountLoginUrl;
          return null;
        }
        if (!response.ok) throw new Error('Wishlist request failed');
        return response.json();
      });
    }

    function sync() {
      requestWishlist().then(function(data) {
        if (!data || !Array.isArray(data.items)) return;
        setSaved(data.items.some(function(item) {
          return item.productId === productId || item.productId === 'gid://shopify/Product/' + productId;
        }));
      }).catch(function() {
        setSaved(false);
      });
    }

    button.addEventListener('click', function() {
      var isSaved = button.getAttribute('aria-pressed') === 'true';
      var nextSaved = !isSaved;

      setBusy(true);
      setSaved(nextSaved);
      requestWishlist({
        method: 'POST',
        headers: {
          'accept': 'application/json',
          'content-type': 'application/json'
        },
        body: JSON.stringify({
          action: nextSaved ? 'add' : 'remove',
          productId: productId,
          imageUrl: button.dataset.productImage || null,
          priceText: button.dataset.productPrice || null
        })
      }).then(function(data) {
        if (!data) return;
        document.dispatchEvent(new CustomEvent('plumimi:wishlist-change'));
      }).catch(function() {
        setSaved(isSaved);
      }).finally(function() {
        setBusy(false);
      });
    });

    sync();
  });


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bowbie-related-products"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-plumimi-related-form]').forEach(function(form) {
    var addButton = form.querySelector('.plumimi-related-products__add');

    form.addEventListener('submit', function(event) {
      if (form.dataset.plumimiSubmitting === 'true') return;

      event.preventDefault();
      if (addButton) addButton.disabled = true;
      form.dataset.plumimiSubmitting = 'true';
      form.submit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plumimi-product-social"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.plumimi-product-social__carousel').forEach(function(carousel) {
    var track = carousel.querySelector('[data-social-track]');
    var previous = carousel.querySelector('[data-social-previous]');
    var next = carousel.querySelector('[data-social-next]');
    if (!track || !previous || !next) return;

    function syncSocialNavigation() {
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll - 2;
      previous.hidden = maxScroll <= 2;
      next.hidden = maxScroll <= 2;
    }

    function scrollSocial(direction) {
      track.scrollBy({ left: direction * Math.max(280, track.clientWidth * 0.72), behavior: 'smooth' });
    }

    previous.addEventListener('click', function() { scrollSocial(-1); });
    next.addEventListener('click', function() { scrollSocial(1); });
    track.addEventListener('scroll', syncSocialNavigation, { passive: true });
    window.addEventListener('resize', syncSocialNavigation, { passive: true });
    syncSocialNavigation();
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["plumimi-series-index"] && !Shopify.designMode) return;
  try {
    
(() => {
  const initialise = (root) => {
    if (root.dataset.seriesReady) return;
    root.dataset.seriesReady = 'true';
    const buttons = Array.from(root.querySelectorAll('[data-series-material]'));
    const panels = Array.from(root.querySelectorAll('[data-series-panel]'));
    const topControls = root.querySelector('[data-series-top]');
    const selectMaterial = (key) => {
      if (!panels.some((panel) => panel.dataset.seriesPanel === key)) key = 'slow';
      panels.forEach((panel) => { panel.hidden = panel.dataset.seriesPanel !== key; });
      buttons.forEach((button) => {
        button.setAttribute('aria-pressed', String(button.dataset.seriesMaterial === key));
      });
      return key;
    };
    const selectFromHash = () => selectMaterial(window.location.hash.replace('#series-', ''));
    selectFromHash();
    root.addEventListener('click', (event) => {
      const button = event.target.closest('[data-series-material]');
      if (!button || !root.contains(button)) return;
      const key = selectMaterial(button.dataset.seriesMaterial);
      const url = new URL(window.location.href);
      url.hash = `series-${key}`;
      window.history.replaceState(window.history.state, '', url);
      if (button.closest('[data-series-bottom]')) {
        const topButton = topControls.querySelector(`[data-series-material="${key}"]`);
        requestAnimationFrame(() => {
          topButton.focus({ preventScroll: true });
          topControls.scrollIntoView({ behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth', block: 'start' });
        });
      }
    });
    window.addEventListener('hashchange', selectFromHash);
  };
  document.querySelectorAll('[data-series-switcher]').forEach(initialise);
  document.addEventListener('shopify:section:load', (event) => {
    event.target.querySelectorAll('[data-series-switcher]').forEach(initialise);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product-recommendations"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('.plumimi-related-products__carousel').forEach(function(carousel) {
    var track = carousel.querySelector('[data-related-products-track]');
    var previous = carousel.querySelector('[data-related-previous]');
    var next = carousel.querySelector('[data-related-next]');
    if (!track || !previous || !next) return;

    function syncProductNavigation() {
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth);
      previous.disabled = track.scrollLeft <= 2;
      next.disabled = track.scrollLeft >= maxScroll - 2;
      previous.hidden = maxScroll <= 2;
      next.hidden = maxScroll <= 2;
    }

    previous.addEventListener('click', function() {
      track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' });
    });
    next.addEventListener('click', function() {
      track.scrollBy({ left: track.clientWidth, behavior: 'smooth' });
    });
    track.addEventListener('scroll', syncProductNavigation, { passive: true });
    window.addEventListener('resize', syncProductNavigation, { passive: true });
    syncProductNavigation();
  });

  document.querySelectorAll('.plumimi-related-products__card').forEach(function(card) {
    var track = card.querySelector('[data-related-card-track]');
    if (!track) return;
    var slides = Array.from(track.children);
    if (slides.length < 2) return;
    var activeIndex = 0;
    var hoverPreviewActive = false;
    var touchPreviewActive = false;
    var touchResetTimer;
    var touchBaseIndex = 0;
    var touchStartX = 0;
    var touchStartY = 0;
    var touchStartTime = 0;
    var mediaSurface = card.querySelector('.plumimi-related-products__media');

    function showSlide(index) {
      activeIndex = (index + slides.length) % slides.length;
      track.style.transform = 'translate3d(' + (-100 * activeIndex) + '%, 0, 0)';
      slides.forEach(function(slide, slideIndex) {
        var isActive = slideIndex === activeIndex;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        slide.tabIndex = isActive ? 0 : -1;
        var video = slide.querySelector('video');
        if (!video) return;
        if (isActive) {
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function() {});
        } else {
          video.pause();
        }
      });
    }

    card.querySelector('.plumimi-related-products__arrow--previous')?.addEventListener('click', function() {
      hoverPreviewActive = false;
      showSlide(activeIndex - 1);
    });
    card.querySelector('.plumimi-related-products__arrow--next')?.addEventListener('click', function() {
      hoverPreviewActive = false;
      showSlide(activeIndex + 1);
    });

    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      card.addEventListener('mouseenter', function() {
        if (activeIndex !== 0) return;
        showSlide(1);
        hoverPreviewActive = true;
      });
      card.addEventListener('mouseleave', function() {
        if (!hoverPreviewActive) return;
        hoverPreviewActive = false;
        showSlide(0);
      });
    }

    if (mediaSurface) {
      mediaSurface.addEventListener('touchstart', function(event) {
        if (event.target.closest('.plumimi-related-products__arrow')) return;
        var touch = event.changedTouches[0];
        if (!touch) return;
        window.clearTimeout(touchResetTimer);
        if (touchPreviewActive) showSlide(touchBaseIndex);
        touchPreviewActive = false;
        touchBaseIndex = activeIndex;
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        touchStartTime = Date.now();
        if (activeIndex === 0) {
          showSlide(1);
          touchPreviewActive = true;
        }
      }, { passive: true });

      mediaSurface.addEventListener('touchend', function(event) {
        if (event.target.closest('.plumimi-related-products__arrow')) return;
        var touch = event.changedTouches[0];
        if (!touch) return;
        var deltaX = touch.clientX - touchStartX;
        var deltaY = touch.clientY - touchStartY;
        var elapsed = Date.now() - touchStartTime;
        var isHorizontalSwipe = Math.abs(deltaX) > 42 && Math.abs(deltaX) > Math.abs(deltaY) * 1.35 && elapsed < 900;
        if (isHorizontalSwipe) {
          event.preventDefault();
          touchPreviewActive = false;
          showSlide(deltaX < 0 ? touchBaseIndex + 1 : touchBaseIndex - 1);
        } else {
          touchResetTimer = window.setTimeout(function () { touchPreviewActive = false; showSlide(touchBaseIndex); }, 1300);
        }
      }, { passive: false });

      mediaSurface.addEventListener('touchcancel', function() {
        if (!touchPreviewActive) return;
        window.clearTimeout(touchResetTimer);
        touchResetTimer = window.setTimeout(function () { touchPreviewActive = false; showSlide(touchBaseIndex); }, 1300);
      }, { passive: true });
    }

    showSlide(0);
  });

  document.querySelectorAll('[data-plumimi-related-form]').forEach(function(form) {
    var addButton = form.querySelector('.plumimi-related-products__add');

    form.addEventListener('submit', function(event) {
      if (form.dataset.plumimiSubmitting === 'true') return;

      event.preventDefault();
      if (addButton) addButton.disabled = true;
      form.dataset.plumimiSubmitting = 'true';
      form.submit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["search-results"]) return;
  try {
    
  document.querySelectorAll('.plumimi-search-card').forEach(function(card) {
    var track = card.querySelector('[data-search-card-track]');
    if (!track) return;
    var slides = Array.from(track.children);
    if (slides.length < 2) return;
    var activeIndex = 0;
    var hoverPreviewActive = false;
    var touchPreviewActive = false;
    var touchBaseIndex = 0;
    var touchStartX = 0;
    var touchStartY = 0;
    var touchStartTime = 0;
    var mediaSurface = card.querySelector('.plumimi-search-card__media');

    function showSlide(index) {
      activeIndex = (index + slides.length) % slides.length;
      track.style.transform = 'translate3d(' + (-100 * activeIndex) + '%, 0, 0)';
      slides.forEach(function(slide, slideIndex) {
        var isActive = slideIndex === activeIndex;
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        slide.tabIndex = isActive ? 0 : -1;
        var video = slide.querySelector('video');
        if (!video) return;
        if (isActive) {
          var playPromise = video.play();
          if (playPromise && typeof playPromise.catch === 'function') playPromise.catch(function() {});
        } else {
          video.pause();
        }
      });
    }

    card.querySelector('.plumimi-search-card__arrow--previous')?.addEventListener('click', function() {
      hoverPreviewActive = false;
      showSlide(activeIndex - 1);
    });
    card.querySelector('.plumimi-search-card__arrow--next')?.addEventListener('click', function() {
      hoverPreviewActive = false;
      showSlide(activeIndex + 1);
    });

    if (window.matchMedia('(hover: hover) and (pointer: fine)').matches) {
      card.addEventListener('mouseenter', function() {
        if (activeIndex !== 0) return;
        showSlide(1);
        hoverPreviewActive = true;
      });
      card.addEventListener('mouseleave', function() {
        if (!hoverPreviewActive) return;
        hoverPreviewActive = false;
        showSlide(0);
      });
    }

    if (mediaSurface) {
      mediaSurface.addEventListener('touchstart', function(event) {
        if (event.target.closest('.plumimi-search-card__arrow')) return;
        var touch = event.changedTouches[0];
        if (!touch) return;
        touchBaseIndex = activeIndex;
        touchStartX = touch.clientX;
        touchStartY = touch.clientY;
        touchStartTime = Date.now();
        if (activeIndex === 0) {
          showSlide(1);
          touchPreviewActive = true;
        }
      }, { passive: true });

      mediaSurface.addEventListener('touchend', function(event) {
        if (event.target.closest('.plumimi-search-card__arrow')) return;
        var touch = event.changedTouches[0];
        if (!touch) return;
        var deltaX = touch.clientX - touchStartX;
        var deltaY = touch.clientY - touchStartY;
        var elapsed = Date.now() - touchStartTime;
        var isHorizontalSwipe = Math.abs(deltaX) > 42 && Math.abs(deltaX) > Math.abs(deltaY) * 1.35 && elapsed < 900;
        touchPreviewActive = false;
        if (isHorizontalSwipe) {
          event.preventDefault();
          showSlide(deltaX < 0 ? touchBaseIndex + 1 : touchBaseIndex - 1);
        } else {
          showSlide(touchBaseIndex);
        }
      }, { passive: false });

      mediaSurface.addEventListener('touchcancel', function() {
        if (!touchPreviewActive) return;
        touchPreviewActive = false;
        showSlide(touchBaseIndex);
      }, { passive: true });
    }

    showSlide(0);
  });

  } catch(e) { console.error(e); }
})();
})();
